export const REVOKE_USER_REQUEST = 'REVOKE_USER_REQUEST'
export const REVOKE_USER_RESET = 'REVOKE_USER_RESET'
export const REVOKE_USER_SUCCESS = 'REVOKE_USER_SUCCESS'
export const REVOKE_USER_ERROR = 'REVOKE_USER_ERROR'
